import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export const Lightbox = ({ image, onClose }) => (
  <Dialog open={!!image} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="lightbox-dialog" className="max-w-md border-0 bg-transparent p-0 shadow-none">
      <DialogTitle className="sr-only">{image?.title || "截圖"}</DialogTitle>
      {image && (
        <img data-testid="lightbox-image" src={image.img} alt={image.title} className="max-h-[85vh] w-full rounded-2xl object-contain" />
      )}
    </DialogContent>
  </Dialog>
);
